export const ruby = {
  1: { value: { base: '{colors.ruby.light.1}', _dark: '{colors.ruby.dark.1}' } },
  2: { value: { base: '{colors.ruby.light.2}', _dark: '{colors.ruby.dark.2}' } },
  3: { value: { base: '{colors.ruby.light.3}', _dark: '{colors.ruby.dark.3}' } },
  4: { value: { base: '{colors.ruby.light.4}', _dark: '{colors.ruby.dark.4}' } },
  5: { value: { base: '{colors.ruby.light.5}', _dark: '{colors.ruby.dark.5}' } },
  6: { value: { base: '{colors.ruby.light.6}', _dark: '{colors.ruby.dark.6}' } },
  7: { value: { base: '{colors.ruby.light.7}', _dark: '{colors.ruby.dark.7}' } },
  8: { value: { base: '{colors.ruby.light.8}', _dark: '{colors.ruby.dark.8}' } },
  9: { value: { base: '{colors.ruby.light.9}', _dark: '{colors.ruby.dark.9}' } },
  10: { value: { base: '{colors.ruby.light.10}', _dark: '{colors.ruby.dark.10}' } },
  11: { value: { base: '{colors.ruby.light.11}', _dark: '{colors.ruby.dark.11}' } },
  12: { value: { base: '{colors.ruby.light.12}', _dark: '{colors.ruby.dark.12}' } },
  a1: { value: { base: '{colors.ruby.light.a1}', _dark: '{colors.ruby.dark.a1}' } },
  a2: { value: { base: '{colors.ruby.light.a2}', _dark: '{colors.ruby.dark.a2}' } },
  a3: { value: { base: '{colors.ruby.light.a3}', _dark: '{colors.ruby.dark.a3}' } },
  a4: { value: { base: '{colors.ruby.light.a4}', _dark: '{colors.ruby.dark.a4}' } },
  a5: { value: { base: '{colors.ruby.light.a5}', _dark: '{colors.ruby.dark.a5}' } },
  a6: { value: { base: '{colors.ruby.light.a6}', _dark: '{colors.ruby.dark.a6}' } },
  a7: { value: { base: '{colors.ruby.light.a7}', _dark: '{colors.ruby.dark.a7}' } },
  a8: { value: { base: '{colors.ruby.light.a8}', _dark: '{colors.ruby.dark.a8}' } },
  a9: { value: { base: '{colors.ruby.light.a9}', _dark: '{colors.ruby.dark.a9}' } },
  a10: { value: { base: '{colors.ruby.light.a10}', _dark: '{colors.ruby.dark.a10}' } },
  a11: { value: { base: '{colors.ruby.light.a11}', _dark: '{colors.ruby.dark.a11}' } },
  a12: { value: { base: '{colors.ruby.light.a12}', _dark: '{colors.ruby.dark.a12}' } },
}
